import { motion } from 'framer-motion'

interface ProgressBarProps {
  progress: number
  stage: string | null
}

export function ProgressBar({ progress, stage }: ProgressBarProps) {
  return (
    <div className="space-y-2 overflow-hidden">
      <div className="flex items-center justify-between gap-2 text-xs">
        <span className="text-star-muted truncate min-w-0">{stage || 'Processing...'}</span>
        <span className="font-mono text-star-dim shrink-0">{progress}%</span>
      </div>
      <div className="h-2 bg-void-100 rounded-full overflow-hidden">
        <motion.div
          className="h-full bg-gradient-to-r from-signal-blue to-signal-purple rounded-full"
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.3 }}
        />
      </div>
    </div>
  )
}
